import { Injectable, inject } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private readonly afAuth = inject(AngularFireAuth);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const requiredRoles = route.data['roles'] as string[] | string | undefined;

    return this.afAuth.authState.pipe(
      take(1),
      switchMap(user => {
        if (!user) {
          this.router.navigate(['/login']);
          return of(false);
        }

        if (!requiredRoles || (Array.isArray(requiredRoles) && requiredRoles.length === 0)) {
          return of(true);
        }

        const rolesToCheck = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];

        return this.authService.hasRoles(rolesToCheck).pipe(
          map(hasRole => {
            if (!hasRole) {
              this.router.navigate(['/unauthorized']);
              return false;
            }

            return true;
          }),
          catchError(() => {
            this.router.navigate(['/login']);
            return of(false);
          })
        );
      })
    );
  }
}
